import React, { useCallback } from "react";

import { Axis, Chart, Legend, LineAdvance, Tooltip } from "bizcharts";
import { IChartProps } from "bizcharts/lib/interface";

import { getClosestGrade } from "../../../utils/reviewUtils";

import { dateFormatter } from "../../../hooks/useFormatDate";
import useTranslations from "../../../hooks/useTranslations";
import useDateFnsLocale from "../../../hooks/useDateFnsLocale";

import { Datum } from "../../reviews/UserFollowUpAnalytics";

type TinyUserGradeOverTimeLineChartProps = {
  datum: Datum;
  options: { value: number; label: string }[];
} & Partial<IChartProps>;

function TinyUserGradeOverTimeLineChart({
  datum,
  options,
  ...chartProps
}: TinyUserGradeOverTimeLineChartProps) {
  const t = useTranslations();
  const dateFnsLocale = useDateFnsLocale();

  const formatter = useCallback(
    (date: string | number | Date) =>
      dateFormatter(
        // Bizcharts internally converts Date to timestamp string
        typeof date === "string" ? parseInt(date) : date,
        t(`dateFormat.short`) as string,
        t("dateFormat.fallback") as string,
        dateFnsLocale
      ),
    [dateFnsLocale]
  );

  return (
    <Chart autoFit height={200} data={datum.data} {...chartProps}>
      <LineAdvance
        position="date*grade"
        color="user"
        shape="smooth"
        tooltip={[
          "user*grade",
          (name, value) => {
            return {
              value: getClosestGrade(options, value).label,
              name,
            };
          },
        ]}
        area
      />
      <Axis name="date" visible={false} />
      <Axis name="grade" visible={false} />
      <Legend name="user" visible={false} />
      <Tooltip
        shared
        showMarkers
        showCrosshairs
        title={(
          _,
          datum: {
            date: Date;
          }
        ) => formatter(datum.date)}
      />
    </Chart>
  );
}

export default React.memo(TinyUserGradeOverTimeLineChart);
